import React from 'react'
import { AdvancedFilter } from 'components/Filter/AdvancedFilter'
import { DepreciationMethodMain } from './DepreciationMethodMain'
import { DepreciationMethodForm } from './DepreciationMethodForm/DepreciationMethodForm'
import { DepreciationMethodDetail } from './DepreciationMethodDetail/DepreciationMethodDetail'

const depreciationMethodRoutes = [
  /* -------------------------------------------- */
  /*                ADVANCED FILTER               */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/assets-change/depreciation-method/filter',
    },
    component: (
      <AdvancedFilter
        mode="assets-change"
        app="fixed-assets"
        hasStatus
        hasDocDate
        hasDateRange
      />
    ),
  },

  /* -------------------------------------------- */
  /*                     MAIN                     */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/assets-change/depreciation-method',
    },
    component: <DepreciationMethodMain />,
  },

  /* -------------------------------------------- */
  /*                     FORM                     */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/assets-change/depreciation-method/add',
    },
    component: <DepreciationMethodForm formMode="add" type="ASSETS_REGISTRATION" />,
  },
  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/assets-change/depreciation-method/edit',
    },
    component: <DepreciationMethodForm formMode="edit" />,
  },
  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/assets-change/depreciation-method/resubmit',
    },
    component: <DepreciationMethodForm formMode="resubmit" />,
  },

  /* -------------------------------------------- */
  /*                    DETAIL                    */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/assets-change/depreciation-method/detail',
    },
    component: <DepreciationMethodDetail />,
  },
]

export default depreciationMethodRoutes
